<template>
  <el-form  :model="ruleForm" :rules="rules" ref="ruleForm"  label-width="80px">
          <div class="oh">
                <div class="fl teacher_left" style="width:300px">
                      <el-form-item label="姓名" prop="realName">
                         <el-input v-model="ruleForm.realName"></el-input>
                      </el-form-item>
                      <el-form-item label="性别" prop="sex">
                          <el-radio-group v-model="ruleForm.sex">
                              <el-radio :label="1">男</el-radio>
                              <el-radio :label="0">女</el-radio>
                       </el-radio-group>
                      </el-form-item>
                      <el-form-item label="出生年月" prop="birthday">
                              <el-date-picker
                                    format="yyyy/MM/dd"  value-format="yyyy/MM/dd"
                                    v-model="ruleForm.birthday"
                                    type="date"
                                    placeholder="选择日期">
                              </el-date-picker>
                               
                      </el-form-item>
                      <el-form-item label="证件类型" prop="idCardType">
                            <el-select placeholder="请选择状态"
                                      v-model="ruleForm.idCardType">
                              <el-option label="身份证"
                                        value="0"></el-option>
                              <el-option label="其他"
                                        value="1"></el-option>
                            </el-select>
                      </el-form-item>
                       <el-form-item label="证件号码" prop="idcard">
                            <el-input v-model="ruleForm.idcard"></el-input>
                      </el-form-item>
                      <el-form-item label="所学专业" prop="profession">
                            <el-input v-model="ruleForm.profession"></el-input>
                      </el-form-item>
                       <el-form-item label="学历" prop="degreeId">
                            <el-select v-model="ruleForm.degreeId">
                                <el-option
                                        v-for="item in degreeIdSelectOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                    </el-form-item>
                      <el-form-item label="所在地" prop="province">
                            <el-select v-model="ruleForm.province"
                                  ref="myProvinceEditor"
                                  filterable
                                  @change="provinceChange()">
                                  <el-option v-for="item in ruleForm.provinceOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                  </el-option>
                              </el-select>
                              <el-select v-model="ruleForm.city"
                                  class="mt5"
                                  ref="myCityEditor"
                                  filterable
                                  no-match-text>
                                  <el-option v-for="item in ruleForm.cityOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                  </el-option>
                              </el-select>
                      </el-form-item>
                     <el-form-item label="毕业院校" prop="college">
                          <el-input  v-model="ruleForm.college"></el-input>
                    </el-form-item>
                     <el-form-item label="工作单位" prop="department">
                          <el-input v-model="ruleForm.department"></el-input>
                    </el-form-item>
                </div>
                <div class="fl ml20" style="width:400px;">
                    <el-form-item label="照片" prop="picture">
                          <el-upload
                                class="avatar-uploader-teacher"
                                :action="ruleForm.imageActionUrl"
                                :show-file-list="false"
                                :data="ruleForm.imageParam"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                            <img v-if="ruleForm.picture" :src="ruleForm.picture" class="avatar-teacher">
                            <i v-else class="el-icon-plus avatar-uploader-icon-teacher"  style="line-height: 178px;"></i>
                         </el-upload>
                         <p class="f12 tip mb20"><span style="color:red">* </span>建议使用250*350的图片,支持jpg/png图片格式</p>
                        <div v-show="ruleForm.showImgError" style="color: #f56c6c;font-size: 12px;line-height: 1;padding-top: 4px;top: 100%;left: 0;">{{ruleForm.showImgErrorMsg}}</div>
                    </el-form-item>
                     <el-form-item label="工作岗位" prop="post">
                          <el-input v-model="ruleForm.post"></el-input>
                    </el-form-item>
                     <el-form-item label="通讯地址" prop="address">
                          <el-input v-model="ruleForm.address"></el-input>
                    </el-form-item>
                     <el-form-item label="手机号码" prop="mobile">
                          <el-input v-model="ruleForm.mobile" :disabled="disabled"></el-input>
                    </el-form-item>
                     <el-form-item label="培训项目" prop="projectName">
                          <el-input v-model="tableData.projectName" :disabled="disabled"></el-input>
                    </el-form-item>
                     <el-form-item label="培训学时" prop="accessValue">
                          <el-input v-model="tableData.accessValue" :disabled="disabled"></el-input>
                    </el-form-item>
                </div>
          </div>
          <div class="mt30 tc">
              <el-button @click="cancel()">取消</el-button>
              <el-button type="primary" :loading="btnDisabled" @click="submitBtn()">确定</el-button>
          </div>
        </el-form>
</template>
<script>

const imageActionUrl = "/"+"api/common/fileUpload/upload";

export default {
  data() {
    return {
      baseDialogVisible: false,
      disabled:true,
      options:[],
      /*省市数组*/
      province: [],
      degreeIdSelectOption:[],//学历
      ruleForm: {
        provinceOptions:[],
        cityOptions:[],
        city: '',
        province: '',
        realName:'',
        sex:'',
        birthday:'',
        picture:'',
        idCardType:'',
        idcard:'',
        profession:'',
        degreeId:'',
        college:'',
        department:'',
        post:'',
        address:'',
        //上传图片额外参数
        imageParam:{'uploadType':'image'},
        //上传地址
        imageActionUrl:imageActionUrl,
        showImgError: false,
        showImgErrorMsg:'请上传图像'
      },
      //规则
        rules: {
            realName: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
            ],
            sex: [
                { required: true, message: '请选择性别', trigger: 'change' }
            ],
            birthday: [
                { type: 'string', required: true, message: '请选择出生年月日', trigger: 'change' }
            ],
            idCardType: [
                { required: true, message: '请选择证件类型', trigger: 'change' }
            ],
            idcard: [
                { required: true, message: '请输入证件号码', trigger: 'change' }
            ],
            profession: [
                { required: true, message: '请输入所学专业', trigger: 'blur' }
            ],
            degreeId: [
                { required: true, message: '请选择学历', trigger: 'change' }
            ],
            province: [
                    {  required: true, message: '请选择省', trigger: 'change' }
                ],
            city: [
                {  required: true, message: '请选择市', trigger: 'change' }
            ],
            college: [
                {  required: true, message: '请输入毕业院校', trigger: 'blur' }
            ],
            department: [
                {  required: true, message: '请输入工作单位', trigger: 'blur' }
            ],
            address: [
                {  required: true, message: '请输入通信地址', trigger: 'blur' }
            ],
            post: [
                {  required: true, message: '请输入工作岗位', trigger: 'blur' }
            ]
        },
      tableData:{},
      //按钮的可用状态
      btnDisabled : false
    };
  },
  methods: {
        handleAvatarSuccess(res, file) {
            if(res.code==='SUCCESS'){
                this.ruleForm.picture = res.data.saveAddress;
                this.ruleForm.showImgError =false;
            }else{
                this.ruleForm.picture =null;
                this.ruleForm.showImgError =true;
                this.ruleForm.showImgErrorMsg='头像上传出错了,请重试!';
                //this.$message.error('头像上传出错了!');
                console.error('头像上传出错了,请重新上传.');
                console.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              //this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
              this.ruleForm.showImgError =true;
              this.ruleForm.showImgErrorMsg='上传头像图片只能是 JPG/PNG 格式!';
              var _this =this;
              //如果此时有原始地址,两秒后让其两秒后隐藏
              if(!this.$util.isBlackStr(this.ruleForm.picture)){
                  setTimeout(function(){
                      _this.ruleForm.showImgError =false;
                  },1000);
              }
              return false;
          }
          if (!isLt2M) {
              //this.$message.error('上传头像图片大小不能超过 2MB!');
              this.ruleForm.showImgError =true;
              this.ruleForm.showImgErrorMsg='上传头像图片大小不能超过 2MB!';
              var _this =this;
              //如果此时有原始地址,两秒后让其两秒后隐藏
              if(!this.$util.isBlackStr(this.ruleForm.picture)){
                  setTimeout(function(){
                      _this.ruleForm.showImgError =false;
                  },1000);
              }
              return false;
          }
          return isJPG && isLt2M;
        },
        /*选省*/
        provinceChange () {
          //清空市下拉选项
          this.ruleForm.city = '';
          this.ruleForm.cityOptions = [];
          if (this.ruleForm.province) {
            this.$axiosPackag.getMessageByAxios("GET", "/api/manager/dictionary/getDictionaryList", { 'parentId':this.ruleForm.province  }, null, null, resD => {
              if (resD) {
                let cityOptionArray = [];
                for (let i = 0; i < resD.length; i++) {
                  let option = {};
                  option.value = resD[i].id;
                  option.label = resD[i].name;
                  cityOptionArray.push(option);
                }
                this.ruleForm.cityOptions = cityOptionArray;
              }
            });
          }
        },
        submitBtn(){
            //只做提示
            if(this.$util.isBlackStr(this.ruleForm.picture)){
                this.ruleForm.showImgError =true;
                this.ruleForm.showImgErrorMsg='请上传图像';
            }
            //验证表单
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    //单独验证一下头像
                    if(this.$util.isBlackStr(this.ruleForm.picture)){
                        this.ruleForm.showImgError =true;
                        this.ruleForm.showImgErrorMsg='请上传图像';
                        this.btnDisabled =false;
                        return ;
                    }
                    let enrollParam = {};
                    enrollParam.realName = this.ruleForm.realName;
                    enrollParam.mobile = this.ruleForm.mobile;
                    enrollParam.idCardType = this.ruleForm.idCardType;
                    enrollParam.idcard = this.ruleForm.idcard;
                    enrollParam.sex = this.ruleForm.sex =='1'? '男' :'女';
                    enrollParam.pictureUrl = this.ruleForm.picture;
                    enrollParam.birthday = this.ruleForm.birthday;
                    enrollParam.profession = this.ruleForm.profession;
                    enrollParam.degreeId = this.ruleForm.degreeId;
                    enrollParam.provinceId= this.$refs.myProvinceEditor.selectedLabel;
                    enrollParam.cityId =this.$refs.myCityEditor.selectedLabel;
                    enrollParam.college = this.ruleForm.college;
                    enrollParam.department = this.ruleForm.department;
                    enrollParam.address = this.ruleForm.address;
                    enrollParam.post = this.ruleForm.post;
                    this.$axiosPackag.getMessageByAxios("POST","/api/student/user/userModify" ,null, enrollParam ,null,resD  =>{
                        this.$axiosPackag.getMessageByAxios("post", "/api/student/userExame/signUpExam",
                            null, {'examId':this.ruleForm.id }, null, res => {
                            this.cancel();
                            this.$confirm('报名成功！若要取消报名，请在开考2周之前取消。', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                    }).then(() => {
                            }); 
	                         this.$parent.$parent.getData();
                            }, errorCall => {
                                this.cancel();
                                this.$message({
                                    type: 'success',
                                    message: resD.message
                                });
                        });
                    },errorCall=>{
                        this.btnDisabled =false;
                    });
                } else {
                    this.btnDisabled =false;
                    return false;
                }
            });
        },
        /**取消关闭弹窗**/
        cancel() {
          this.$parent.$parent.refresh(false);
        },
        getData() {
              if (this.ruleForm.id != "") {
                    this.$axiosPackag.get(
                      "/api/student/userExame/getUserSignUpInfo",
                      { 'examId':this.ruleForm.id },
                      resD => {
                        this.ruleForm.realName =resD.studentVo.realName;
                        this.ruleForm.sex = resD.studentVo.sex =='男'? 1 :0;
                        this.ruleForm.idcard = resD.studentVo.idcard;
                        this.ruleForm.birthday = resD.studentVo.birthday;
                        this.ruleForm.idCardType = resD.studentVo.idCardType =='1'? '1' :'0';
                        this.ruleForm.idcard = resD.studentVo.idcard;
                        this.ruleForm.mobile = resD.studentVo.mobile;
                        this.ruleForm.profession = resD.studentVo.profession;
                        this.ruleForm.degreeId = resD.studentVo.degreeId;
                        this.ruleForm.college = resD.studentVo.college;
                        this.ruleForm.department = resD.studentVo.department;
                        this.ruleForm.jobTitle = resD.studentVo.photoUrl;
                        this.ruleForm.picture = resD.studentVo.picture;
                        this.ruleForm.post = resD.studentVo.post;
                        this.ruleForm.address = resD.studentVo.address;
                        this.ruleForm.province= resD.studentVo.province;
                        this.ruleForm.city =resD.studentVo.city;
                        this.tableData = resD;
                      }
                    );
              }
        },
        init(id) {
            this.ruleForm.id = id;
            this.loading = false;
            if(id!=null){
              this.getData();
            }
        }
    },
    created: function () {
            /*获取学历*/
            this.$axiosPackag.getMessageByAxios("GET","/api/manager/dictionary/getDictionaryList",{'parentId':'005'},null,null, resD =>{
                if(resD){
                    let degreeIdArray = [];
                    for(let i=0 ;i<resD.length ;i++){
                        let  option  ={};
                        option.value =resD[i].id;
                        option.label =resD[i].name;
                        degreeIdArray.push(option);
                    }
                    this.degreeIdSelectOption = degreeIdArray ;
                }
            });
            /*获取省*/
            this.$axiosPackag.getMessageByAxios("GET","/api/manager/dictionary/getDictionaryList",{'parentId':'002'},null,null, resD =>{
                if (resD) {
                    let provincesOptionArray = [];
                    for (let i = 0; i < resD.length; i++) {
                        let option = {};
                        option.value = resD[i].id;
                        option.label = resD[i].name;
                        provincesOptionArray.push(option);
                    }
                    this.ruleForm.provinceOptions = provincesOptionArray;
                }
            });
    },
};
</script>


// WEBPACK FOOTER //
// enrollEdit.vue?1013e44d